import script from "./TressProductTile.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressProductTile.vue?vue&type=script&lang=ts&setup=true"

import "./TressProductTile.vue?vue&type=style&index=0&id=41d15770&lang=scss"

const __exports__ = script;

export default __exports__